import { useMutation } from '@tanstack/react-query';
import { TiktokAudio } from '@round/api';
import { findOrCreateTiktokAudio } from 'Modules/TikTok/TikTok.services';

export function useFindOrCreateTiktokAudio() {
    const { mutateAsync, isPending, error } = useMutation<TiktokAudio, Error, string>({
        mutationFn: async (url: string) => {
            const result = await findOrCreateTiktokAudio(url);
            if (!result.success) {
                throw new Error(result.error);
            }
            return result.data;
        },
    });

    return { findOrCreate: mutateAsync, isLoading: isPending, error };
}
